import { useAppSelector } from 'src/redux_store';
import { ERoleLevel } from 'src/types/enum';

export const usePermission = (permission: string[]) => {
  const { me } = useAppSelector((state) => state.myAccountSlice);
  if (!me) return false;
  if ([ERoleLevel.SUPER_ADMIN, ERoleLevel.SYSTEM_ADMIN].includes(me.role?.level)) {
    return true;
  }
  return permission.some((p) => me?.role?.permissions.includes(p));
};
